export default "__VITE_ASSET__6466ffe6__"